/**
 * Design system component: FilterTabStrip
 *
 * Underline-style tab bar for filtering item lists (e.g. All / Available /
 * Borrowed / Mine). Each tab uses `flex: 1` so tabs spread evenly across
 * the full container width rather than clustering on the left.
 *
 * Active tab: accent colour text + 2px accent underline, weight 700.
 * Inactive tab: muted text, transparent underline, weight 400.
 * Tab change animates over 150ms for a smooth feel.
 */
import { T } from '@/lib/tokens';

interface FilterTabStripProps {
  tabs: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

/**
 *
 * @param root0
 * @param root0.tabs
 * @param root0.activeTab
 * @param root0.onTabChange
 */
export function FilterTabStrip({ tabs, activeTab, onTabChange }: FilterTabStripProps) {
  return (
    <div style={{ display: 'flex' }}>
      {tabs.map((tab) => {
        const isActive = tab === activeTab;
        return (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            aria-current={isActive ? 'true' : undefined}
            style={{
              flex: 1,
              padding: '10px 4px 12px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              color: isActive ? T.accent : T.textMuted,
              fontSize: 13,
              fontFamily: 'inherit',
              fontWeight: isActive ? 700 : 400,
              borderBottom: `2px solid ${isActive ? T.accent : 'transparent'}`,
              transition: 'all 0.15s',
            }}
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
}
